// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"sQ-z","inlineTitle":"tQ-z","sponsoredAdsWrapper":"uQ-z","marketplaceRecosWrapper":"vQ-z"};